import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {LookupConfigSpec} from 'lookup-config/LookupConfigModalConstants';
import {MappableProcessType} from 'processes/ProcessConstants';
import {Schema} from 'schemas/SchemaConstants';

type TaskSchema = Schema & {outputSchema: Schema | null; executionType: ProcessExecutionType};

export interface SchemaInfo {
  taskSchema: TaskSchema;
  itemType: MappableProcessType;
  canChangeItemType?: boolean;
}

export function getSchemaFromSchemaInfo(schemaInfo: SchemaInfo): Schema {
  return schemaInfo.itemType === ModelTypeConstants.PROCESS_TASK
    ? schemaInfo.taskSchema
    : schemaInfo.taskSchema.outputSchema!;
}

export interface FieldToFieldMapperData {
  [id: string]: {
    lookupConfig: LookupConfigSpec | null;
    fromSchemaId: string | null;
    resultMustBeNonNullToMap: boolean;
  };
}
